import styled from 'styled-components';
import breakpoint from '../breakpoints';
import './fonts.css';

const trackingToLetterSpacing = (spacing) => `${spacing/1000}em`;

export default {
  Heading1: styled.h1`
    font-family: 'ToyotaType Semibold';
    font-weight: bold;
    letter-spacing: ${trackingToLetterSpacing(50)};

    font-size: 24px;
    line-height: 32px;
    ${breakpoint('tablet', 'up')} {
      font-size: 40px;
      line-height: 32px;
    }
  `,
  Heading2: styled.h2`
    font-family: 'ToyotaType Semibold';
    font-weight: bold;
    letter-spacing: ${trackingToLetterSpacing(25)};
    
    font-size: 30px;
    line-height: 36px;
    /* ${breakpoint('tablet', 'up')} {
      font-size: 40px;
      line-height: 1.2;
    } */
    ${breakpoint('desktop', 'up')} {
      font-size: 50px;
      line-height: 1.2;
    }
  `,
  Heading3: styled.h3`
    font-family: 'ToyotaType Semibold';
    font-weight: bold;
    letter-spacing: ${trackingToLetterSpacing(50)};
    font-size: 20px;
    line-height: 1.5;

    ${breakpoint('tablet', 'up')} {
      font-size: 25px;
      line-height: 1.5;
    }
    ${breakpoint('mobile', 'up')} {
      line-height: 1.6;
    }
  `,
  Body: styled.span`
    font-family: 'ToyotaType Book';
    letter-spacing: ${trackingToLetterSpacing(50)};

    font-size: 13px;
    line-height: 18px;
    ${breakpoint('tablet', 'up')} {
      font-size: 16px;
      line-height: 24px;
    }
  `,
  BodyBold: styled.span`
    font-family: 'ToyotaType Bold';
    letter-spacing: ${trackingToLetterSpacing(50)};

    font-size: 13px;
    line-height: 18px;
    ${breakpoint('tablet', 'up')} {
      font-size: 16px;
      line-height: 24px;
    }
  `,
  BodySmall: styled.span`
    font-family: 'ToyotaType Book';
    font-size: 13px;
    line-height: 20px;
    letter-spacing: ${trackingToLetterSpacing(50)};
  `,
  BodyExtraSmall: styled.span`
    font-family: 'ToyotaType Book';
    font-size: 10px;
    line-height: 18px;
    letter-spacing: ${trackingToLetterSpacing(50)};
  `,
  NavItem: styled.span`
    font-family: 'ToyotaType Semibold';
    font-weight: bold;
    text-decoration: none;
    letter-spacing: ${trackingToLetterSpacing(50)};
    color: inherit;
    font-size: 13px;
    line-height: 1.2px;
    ${breakpoint('tablet', 'up')} {
      font-size: 16px;
      line-height: 24px;
    }
  `,
  Tagline: styled.span`
    font-family: 'ToyotaType Semibold';
    font-weight: bold;
    font-size: 13px;
    letter-spacing: ${trackingToLetterSpacing(75)};
    line-height: 14px;
  `
};
